import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Picker } from 'Components/Modals/Investment/picker';

const styles = () => ({
  root: {
  },
});

const KnockoutModal = ({
  className,
  classes,
  ...rest
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Picker {...rest} />
    </Box>
  );
};

KnockoutModal.defaultProps = {
  className: '',
};

KnockoutModal.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(KnockoutModal);
